import React, { Fragment } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { motion } from 'framer-motion';
export function Doctor() {
  const {
    t
  } = useLanguage();
  const credentials = t('doctor.credentials');
  const institutions = t('doctor.institutions');
  const easeOutCubic = [0.33, 1, 0.68, 1];
  return <section id="doctor" className="py-24 lg:py-40 bg-white overflow-hidden" data-id="element-91">
      <div className="container mx-auto px-6" data-id="element-92">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center max-w-6xl mx-auto" data-id="element-93">
          {/* Photo column with editorial frame */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 1,
          ease: easeOutCubic
        }} className="relative" data-id="element-94">
            {/* Decorative offset frame — soft gold/blush */}
            <div className="absolute -top-6 -right-6 lg:-top-8 lg:-right-8 w-full h-full rounded-[2rem] border border-brand-gold/30 -z-10" data-id="element-95"></div>
            <div className="absolute -bottom-6 -left-6 lg:-bottom-8 lg:-left-8 w-32 h-32 bg-brand-blush/40 rounded-full blur-3xl -z-10" data-id="element-96"></div>

            <div className="aspect-[3/4] rounded-[2rem] overflow-hidden relative z-10 bg-brand-stone" data-id="element-97">
              <img src="https://cdn.magicpatterns.com/uploads/rbQMAePHJ6ba4mMbeKataW/ChatGPT_Image_May_29,_2026,_12_31_15_PM.png" alt={t('doctor.name')} className="w-full h-full object-cover object-center" data-id="element-98" />
              {/* Subtle warm overlay to tie into the page palette */}
              <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/10 via-transparent to-transparent pointer-events-none" data-id="element-99"></div>
            </div>

            {/* Floating credential mini-card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            delay: 0.5,
            ease: easeOutCubic
          }} className="absolute -bottom-6 right-4 lg:right-8 bg-brand-cream/95 backdrop-blur-md border border-brand-stone/40 rounded-2xl px-6 py-4 z-20 shadow-sm" data-id="element-100">
              <div className="flex items-center gap-3" data-id="element-101">
                <span className="w-6 h-px bg-brand-gold" data-id="element-102"></span>
                <p className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/60" data-id="element-103">
                  Johns Hopkins
                </p>
              </div>
            </motion.div>
          </motion.div>

          {/* Text column */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: easeOutCubic
        }} data-id="element-104">
            <div className="inline-flex items-center gap-3 mb-6" data-id="element-105">
              <span className="w-8 h-px bg-brand-gold" data-id="element-106"></span>
              <span className="text-brand-dark/50 font-medium tracking-[0.25em] text-[10px] uppercase" data-id="element-107">
                {t('doctor.eyebrow')}
              </span>
            </div>

            <h2 className="text-5xl lg:text-6xl font-serif font-light text-brand-dark mb-6 tracking-tight" data-id="element-108">
              {t('doctor.name')}
            </h2>

            <div className="flex flex-wrap items-center gap-4 mb-10" data-id="element-109">
              {credentials.map((cred: string, idx: number) => <Fragment key={idx} data-id="element-110">
                  <span className="text-xs font-medium tracking-widest uppercase text-brand-dark/60" data-id="element-111">
                    {cred}
                  </span>
                  {idx < credentials.length - 1 && <span className="text-brand-gold text-xs" data-id="element-112">·</span>}
                </Fragment>)}
            </div>

            <p className="text-lg lg:text-xl text-brand-dark/70 font-light leading-relaxed mb-12" data-id="element-113">
              {t('doctor.bio')}
            </p>

            <div className="pt-8 border-t border-brand-stone/50" data-id="element-114">
              <p className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/40 mb-4" data-id="element-115">
                Formación
              </p>
              <div className="flex flex-wrap gap-x-8 gap-y-3" data-id="element-116">
                {institutions.map((inst: string, idx: number) => <div key={idx} className="text-sm font-serif font-light text-brand-dark/70 italic" data-id="element-117">
                    {inst}
                  </div>)}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}